import React,{useEffect, useState} from 'react'
import API from '../../../../../API/API'
import $ from 'jquery'

function SubmitMappings(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [allUpdatedMappings, setAllUpdatedMappings] = useState()
    useEffect(() => {

    },[])

    const submitSelectedMappings = () =>{
        var allMapping = []
        $("#multiLocationMappingTable tr").each(function(){
            var mappingTable = {
                IsDefault: $(this).find("td:nth-child(3)").attr("headers") === "true" ? true : false,
                EcommerceMethod: $(this).find("td:nth-child(2) option:selected").text(),
                ErpMethod: $(this).find("td:nth-child(1) option:selected").text(),
                ErpLocationId: $(this).find("td:nth-child(1)").attr("headers"),
                EcommerceLocationId: $(this).find("td:nth-child(2)").attr("headers"),
                isEcommerceDefault: false, //Need Clarification
                isErpDefault: false //Need Clarification
            }
            allMapping.push(mappingTable)
        })
        setIsLoading(true);
        var response =window.localStorage.getItem("accessToken") ;
        const headers={
            "authorization": `Bearer ${response}`,
            "content-type" : "application/json"
        };
        const body = allMapping
        API.post(`/Connection/${props.connectorId}/instance/${props.instancesId}/location-mappings`, body, { headers })
        .then((response) => {
            if(response.status === 200){
                setIsLoading(false);
            }
        })
    }


    return (
        <>
            {isLoading ?
                <div className="spinner-container">
                    <div className="loading-spinner"></div>
                </div> : null
            }

            <button className='submitButton' onClick={submitSelectedMappings}>
                Submit Mappings
            </button>
        </>
        
    )
}

export default SubmitMappings
